module.exports = __webpack_public_path__ + "4644b104c2ec69ae16e9581f7b6724b8.pdf";